import * as Mod1 from "./discourse/api-initializers/bbcode-rich-editor";
import * as Mod2 from "./discourse/lib/rich-editor-extension";
import * as Mod3 from "./lib/discourse-markdown/bbcode-values";
import * as Mod4 from "./lib/discourse-markdown/bbcode";
const compatModules = {
  "discourse/api-initializers/bbcode-rich-editor": Mod1,
  "discourse/lib/rich-editor-extension": Mod2,
  "lib/discourse-markdown/bbcode-values": Mod3,
  "lib/discourse-markdown/bbcode": Mod4,
};
export { compatModules };
export default compatModules;
